import React from 'react';
import { ProgressBar } from '../ui-kit';
import Loader from '../general/Loader';
import round from '../../utils/round';

const ContractStatisticsProgress = ({ contractStatistics, showAllocatedOnly, customClassName }) => {
  if (!contractStatistics && !contractStatistics?.loaded) {
    return <Loader />;
  } else if (!contractStatistics.user_id) return null;

  // If there is no target, we just show a blue bar indicating that it is fulfilled
  if (String(contractStatistics.target_workload) === '0.0') {
    return (
      <ProgressBar className={customClassName}>
        <ProgressBar
          now={100}
          label={I18n.t('activerecord.attributes.reporting/contracts/contract.performed_workload')}
        />
      </ProgressBar>
    );
  }

  let performedPercentage = contractStatistics.performed_ratio * 100;
  let allocatedPercentage = (contractStatistics.allocated_ratio - contractStatistics.performed_ratio) * 100;
  // Make sure that performed workload is a number, not a string
  let performedWorkload = contractStatistics.performed_workload;
  let allocatedWorkload = contractStatistics.allocated_workload;

  // If set, don't split up the progress bar into multiple pieces, but show 1
  // number
  if (showAllocatedOnly) {
    performedWorkload = 0;
    performedPercentage = 0;
  }

  let performedWorkloadString = `${I18n.t(
    'activerecord.attributes.reporting/contracts/contract.performed_workload'
  )} ${round(performedWorkload, 1)} (${round(performedPercentage, 2)}%)`;
  let allocatedWorkloadString = `${I18n.t(
    'activerecord.attributes.reporting/contracts/contract.scheduled_workload'
  )} ${round(allocatedWorkload - performedWorkload, 1)} (${round(allocatedPercentage, 2)}%)`;

  // If the total percentage exceeds 100%, the progress bar will not be able to fit
  // both bars. To fix this, we recalculate the percentage that each value represent
  const totalPercentage = allocatedPercentage + performedPercentage;
  if (totalPercentage > 100) {
    performedPercentage = (performedPercentage / totalPercentage) * 100;
    allocatedPercentage = (allocatedPercentage / totalPercentage) * 100;
  }

  return (
    <ProgressBar className={customClassName}>
      <ProgressBar
        now={performedPercentage}
        key={1}
        label={performedWorkloadString}
        title={I18n.t('activerecord.attributes.reporting/contracts/contract.performed_workload')}
      />
      <ProgressBar
        variant="success"
        now={allocatedPercentage}
        key={2}
        label={allocatedWorkloadString}
        title={I18n.t('activerecord.attributes.reporting/contracts/contract.allocated_workload')}
      />
    </ProgressBar>
  );
};

export default ContractStatisticsProgress;
